var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24ActioinsClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-actioins-clear",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M11.848,10.438a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0L6,7.408l-4.44,4.44a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L4.588,6,.148,1.558a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0L6,4.588l4.44-4.44a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71L7.408,6Z",
    transform: "translate(6.002 6.002)",
    fill: "#a7a7a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24ActioinsClear);
export default __webpack_public_path__ + "static/media/icon-24-actioins-clear.98e58a9b1dc9156bd95ab3398550a29f.svg";
export { ForwardRef as ReactComponent };